// frontend/packages/business-console/src/components/inbox/MessageThread.jsx

import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";

import MessageBubble from "./MessageBubble";

/**
 * Renders the chronological message stream for a conversation. Auto-scrolls
 * to the latest message when the list grows (e.g., after a reply is sent).
 */
export default function MessageThread({ messages }) {
  const list = Array.isArray(messages) ? messages : [];
  const endRef = useRef(null);

  useEffect(() => {
    if (endRef.current) {
      endRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [list.length]);

  if (list.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          No messages in this conversation yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", py: 1 }}>
      {list.map((m) => (
        <MessageBubble key={m._id || m.id} message={m} />
      ))}
      <div ref={endRef} />
    </Box>
  );
}
